<div bsModal #equipmentDetails="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content" data-bind="with: entity">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                <h3 class="modal-title" id="myModalLabel">
                    {{ equipment.Serial }} ({{ model?.Name }} {{ poweredBy?.Name }}) &bull; Details
                </h3>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4">
                        <div>
                            <span>Date Last Modified </span>
                            <i class="fa fa-ellipsis-v"></i>
                             {{ equipment.Modified | amDateFormat: 'MM/DD/YYYY' }}
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="center-block">
                            <span>Equipment Operates at </span>
                            <i class="fa fa-ellipsis-v"></i>
                             {{ minesite?.Name }}
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="pull-right">
                            <span>Status </span>
                            <i class="fa fa-ellipsis-v"></i>
                             {{ equipment.Active ? 'Active' : 'Inactive' }}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Associated Accounts</span>
                                    <span class="badge pull-right">{{ users.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let user of users">
                                        <div class="list-group-item-heading">
                                            <b>{{ user.FirstName }} {{ user.LastName }}</b>
                                        </div>
                                        <div class="list-group-item-text">
                                            {{ user.UserName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Parent Company Associations</span>
                                    <span class="pull-right badge">{{ companies.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let company of companies">
                                        <div class="list-group-item-heading">
                                            <b>{{ company.Name }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-12" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Associated Documentation</span>
                                    <span class="pull-right badge">{{ documents.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <div class="list-group">
                                    <div class="list-group-item list-group-item-info" *ngFor="let document of documents">
                                        <div class="row">
                                            <div class="list-group-item-heading col-lg-9">
                                                <b>{{ document.ProductName }} ({{ document.FileName }})</b>
                                            </div>
                                            <div class="list-group-item-text  col-lg-6">
                                                {{ document.Version }} ({{ document.VersionDate | amDateFormat: 'MM/DD/YYYY' }})
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>